import { render, staticRenderFns } from "./index_column_video.vue?vue&type=template&id=38ce901d"
import script from "./index_column_video.vue?vue&type=script&lang=js"
export * from "./index_column_video.vue?vue&type=script&lang=js"
import style0 from "./index_column_video.vue?vue&type=style&index=0&id=38ce901d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports